// @flow
import {injectIntl} from "react-intl"
import {List, ListItem} from "material-ui/List"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import MenuItem from "material-ui/MenuItem"
import * as React from "react"
import SelectField from "material-ui/SelectField"
import Toggle from "material-ui/Toggle"
import * as Util from "../common"

const M = Util.intlMessages("view.Options")

const enums = ["standard", "scientific", "engineering", "longScale"]
const enumset = new Set(enums)
export const NumberFormatChooserRender = injectIntl(props => {
  if (props.isError) return <Util.Error error={props} />
  let {numberformat, setNumberformat, request, intl} = props
  numberformat = enumset.has(numberformat) ? numberformat : "standard"
  const ex1 = <Util.Num val={123.456e6} />
  const ex2 = <Util.Num val={123.456e9} />
  const ex3 = <Util.Num val={123.456e36} />
  return (
    <div>
      <ListItem>
        <SelectField
          value={numberformat}
          onChange={(event, index, value) => setNumberformat(value)}
          floatingLabelText={intl.formatMessage({
            id: "view.Options.NumberFormatChooser.title",
          })}
        >
          {enums.map(name => (
            <MenuItem
              key={name}
              value={name}
              primaryText={<M id={`NumberFormatChooser.${name}`} />}
            />
          ))}
        </SelectField>
        <div>
          {request.status === "pending" ? (
            <Util.LoadingSpinner style={{display: "inline"}} />
          ) : (
            <M id="NumberFormatChooser.examples" values={{ex1, ex2, ex3}} />
          )}
          {request.status === "error" ? JSON.stringify(request) : null}
        </div>
      </ListItem>
    </div>
  )
})
export const NumberFormatChooser = containers.options.NumberFormatChooser(
  NumberFormatChooserRender,
)

const IsDebugChooserRender = props => {
  if (props.isError) return <Util.Error error={props} />
  const {isDebug, setIsDebug, request} = props
  return (
    <div>
      <ListItem>
        <Toggle
          label={<M id="IsDebug.title" />}
          labelPosition="right"
          toggled={!!isDebug}
          onToggle={() => setIsDebug(!isDebug)}
        />
      </ListItem>
      {request.status === "pending" ? (
        <Util.LoadingSpinner style={{display: "inline"}} />
      ) : null}
      {request.status === "error" ? JSON.stringify(request) : null}
    </div>
  )
}
export const IsDebugChooser = containers.options.IsDebugChooser(
  IsDebugChooserRender,
)

const PrereleaseFlagsChooserRender = props => {
  if (props.isError) return <Util.Error error={props} />
  const {prereleaseFlags, setPrereleaseFlags, isVisible, request} = props
  if (!isVisible) return null
  return (
    <div>
      <ListItem>
        {/*secondaryText={<M id="PrereleaseFlags.description" />}*/}
        <Toggle
          label={<M id="PrereleaseFlags.title" />}
          labelPosition="right"
          toggled={!!prereleaseFlags}
          onToggle={() => setPrereleaseFlags(!prereleaseFlags)}
        />
      </ListItem>
      {request.status === "pending" ? (
        <Util.LoadingSpinner style={{display: "inline"}} />
      ) : null}
      {request.status === "error" ? JSON.stringify(request) : null}
    </div>
  )
}
export const PrereleaseFlagsChooser = containers.options.PrereleaseFlagsChooser(
  PrereleaseFlagsChooserRender,
)

let Options = () => (
  <div>
    <Toolbar>
      <ToolbarGroup>
        <ToolbarTitle text={<M id="title" />} />
      </ToolbarGroup>
    </Toolbar>
    <List className="view-options">
      <NumberFormatChooser />
      <IsDebugChooser />
      <PrereleaseFlagsChooser />
    </List>
  </div>
)
export default Options



// WEBPACK FOOTER //
// ./src/options/OptionsView.js